export default "/images/1c478278917acdc0c3fb9e25cfcc2008.avif";